
import {
  Component,
  // Prop,
  Vue
  // Model,
  // Provide,
  // Watch
} from "vue-property-decorator";
// import { objAny, objStr, objNumber } from "../../common/common-interface";
@Component
export default class SystemConfigOnlineuser extends Vue {
  // private test: string = "light";
}
